import {Component, inject, Inject, PLATFORM_ID} from '@angular/core';
import {HeaderComponent} from "../../common/header/header.component";
import {NavigationCancel, NavigationEnd, Router, RouterOutlet} from "@angular/router";
import {SidebarComponent} from "../../common/sidebar/sidebar.component";
import {ToggleService} from "../../common/header/toggle.service";
import { CommonModule, isPlatformBrowser } from "@angular/common";
import {filter} from "rxjs/operators";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'app-main-layout',
    imports: [
        RouterOutlet, CommonModule, SidebarComponent, HeaderComponent
    ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {

    title = 'Trinta -  Angular 19 Material Design Admin Dashboard Template';
    routerSubscription: any;
    location: any;
    public authService = inject(AuthService);

    constructor(
        public router: Router,
        public toggleService: ToggleService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.toggleService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    // Toggle Service
    isToggled = false;

    // Dark Mode
    toggleTheme() {
        this.toggleService.toggleTheme();
    }

    // Settings Button Toggle
    toggle() {
        this.toggleService.toggle();
    }

    // ngOnInit
    ngOnInit(){
        if (isPlatformBrowser(this.platformId)) {
            this.recallJsFuntions();
        }
    }

    // recallJsFuntions
    recallJsFuntions() {
        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
            .subscribe(event => {
                this.location = this.router.url;
                if (!(event instanceof NavigationEnd)) {
                    return;
                }
                this.scrollToTop();
            });
    }
    scrollToTop() {
        if (isPlatformBrowser(this.platformId)) {
            window.scrollTo(0, 0);
        }
    }

}
